<div *ngIf="isLoading" class="overlay">
  <mat-progress-spinner
    mode="indeterminate">
  </mat-progress-spinner>
</div>
